<template>
  <!-- 转入公海/长期维护/换跟进人/继续跟进表单 -->
  <el-form
    ref="formRef"
    :model="formData"
    label-width="120px"
    style="width: 550px;padding-top: 20px;"
    v-loading="loading"
  >
    <!-- 转入公海类型 -->
    <el-form-item
      v-if="['showPublicsea'].includes(modalType)"
      label="将该线索"
      prop="publicPoolType"
      :rules="[
        { required: true, message: '请选择转入公海的类型', trigger: 'change' }
      ]"
    >
      <el-radio-group v-model="formData.publicPoolType">
        <el-radio label="incubate">转入公海孵化池</el-radio>
        <el-radio label="push">转入公海推进池</el-radio>
      </el-radio-group>
    </el-form-item>
    
    <!-- 申请原因 -->
    <custom-form-item
      v-if="['showPublicsea', 'showLongTime'].includes(modalType)"
      type="input"
      labelWidth="120px"
      prop="apply_reason_formCode_FR006"
      v-model="formData.apply_reason_formCode_FR006"
      :fieldInfo="showFormFieldKeyInfo.apply_reason_formCode_FR006 || {}"
    />
    <!-- 截止时间 -->
    <custom-form-item
      v-if="['showPublicsea', 'showLongTime'].includes(modalType)"
      type="date"
      labelWidth="120px"
      prop="expired_formCode_FR006"
      v-model="formData.expired_formCode_FR006"
      :fieldInfo="showFormFieldKeyInfo.expired_formCode_FR006 || {}"
    />
    <!-- 选择跟进人 -->
    <el-form-item
      v-if="['showChangeFollower', 'showContinueFollow'].includes(modalType)"
      :label="modalType === 'showChangeFollower' ? '新跟进人' : '跟进人'"
      prop="follower"
      :rules="[
        { required: true, message: '请选择跟进人', trigger: 'blur' }
      ]"
    >
      <el-select
        v-model="formData.follower"
        style="width: 100%;"
        placeholder="请选择跟进人"
        size="small"
        clearable
        filterable
        remote
        :remote-method="remoteSearchEmployee"
      >
        <el-option v-for="item in filteredEmployeeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item> 
    <!-- 开始阶段 -->
    <el-form-item
      v-if="['showChangeFollower', 'showContinueFollow'].includes(modalType)"
      label="开始阶段"
    >
      <el-select
        v-model="formData.beginStage"
        style="width: 100%;"
        placeholder="请选择"
        disabled
        size="small"
      >
        <el-option label="信息采集" value="S020"></el-option>
        <el-option label="邀约参观" value="S040"></el-option>
      </el-select>
    </el-form-item> 
  </el-form>
</template>

<script>
import request from '@/utils/request'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'

const transferFormCode = 'FR006'

export default {
  name: 'TransferOrChangeClueForm',
  props: {
    // 弹窗类型(showPublicsea/showLongTime/showChangeFollower/showContinueFollow)
    modalType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      // 表单数据
      formData: {
        publicPoolType: '', // 转入公海类型
        apply_reason_formCode_FR006: '', // 申请原因
        expired_formCode_FR006: '', // 截止时间
        follower: '', // 跟进人
        beginStage: '' // 开始阶段
      },
      showFormFieldKeyInfo: {},
      originOptionsInfo: {},
      employeeOptions: []
    }
  },
  computed: {
    // 过滤后的员工列表
    filteredEmployeeOptions() {
      if (!this.formData.follower) {
        return []
      }
      // 根据搜索关键字过滤员工列表
      const keyword = this.formData.follower.toString().toLowerCase()
      return this.employeeOptions.filter(item => 
        item.label.toString().toLowerCase().includes(keyword) || 
        item.value.toString().toLowerCase().includes(keyword)
      )
    }
  },
  created() {
    // 组件创建时根据 modalType 加载数据
    if (this.modalType) {
      this.init(this.modalType)
    }
  },
  methods: {
    async init(modalType) {
      this.loading = true
      try {
        switch (modalType) {
          // 更换跟进人
          case 'showChangeFollower':
            this.formData.beginStage = 'S020'
            await this.getEmployeeOptions()
            break
          // 继续跟进
          case 'showContinueFollow':
            this.formData.beginStage = 'S040'
            await this.getEmployeeOptions()
            break
          // 转长期维护
          case 'showLongTime':
            await this.getFormFieldList()
            this.formData['clue_apply_id_formCode_' + transferFormCode] = await formFlow.createFormId()
            break
          // 转入公海
          case 'showPublicsea':
            await this.getFormFieldList()
            this.formData['clue_apply_id_formCode_' + transferFormCode] = await formFlow.createFormId()
            break
        }
      } catch (error) {
        console.log('初始化数据请求失败', error)
      } finally {
        this.loading = false
      }
    },

    async getFormFieldList() {
      const {
        formData,
        showFormFieldKeyInfo,
        originOptionsInfo
      } = await formFlow.getFormFieldList([transferFormCode])

      this.showFormFieldKeyInfo = showFormFieldKeyInfo
      // 合并表单默认值到 formData
      this.formData = formData
      this.originOptionsInfo = originOptionsInfo
    },

    // 获取员工列表
    async getEmployeeOptions() {
      try {
        const res = await request.get('/cluepool/pc/user/all', {}, '')
        if (res.code === 200) {
          this.employeeOptions = (res.data || []).map(item => ({
            label: item.nickName,
            value: item.workNumber
          }))
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('请求员工列表数据请求失败', error)
      }
    },

    // 远程搜索员工
    remoteSearchEmployee(query) {
      if (query !== '') {
        this.formData.follower = query
      } else {
        this.formData.follower = ''
      }
    },

    // 表单验证（供父组件通过 ref 调用）
    validate(callback) {
      return this.$refs.formRef.validate(callback)
    },

    // 重置表单（供父组件通过 ref 调用）
    resetFields() {
      this.$refs.formRef.resetFields()
    }
  },
  components: {
    CustomFormItem: () => import('@/views/DoctorVisitLTC/components/customFormItem/CustomFormItem.vue'),
  }
}
</script>
